module.exports = __webpack_public_path__ + "img/atenciones.654d0857.png";